import { Component } from 'react';
import TableWithoutPaginationOrange from "../Table/TableWithoutPaginationOrange"
import "./Absences.css";
import "../../utils.css";

class AbsenceTable extends Component {
    render() {
        let filterableIsDefined = this.props.filterable !== undefined;

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 row without-side-padding absence-table">
                <TableWithoutPaginationOrange
                    filterable = { filterableIsDefined ? this.props.filterable : true }
                    data={ this.props.data }
                    columns={ this.props.columns }
                    getTrProps={ this.props.getTrProps }
                    className="tableWithoutPaginationCustomClass"
                />
            </div>
        );
    }
}

export default (AbsenceTable);
